import React from 'react';
import { connect } from 'react-redux';

import Trazer from '../components/Trazer/Trazer';
function TrazerContainer (state) {
  return <Trazer />;
}

const mapStateToProps = state => ({});

const mapDispatchToPropsActions = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToPropsActions
)(TrazerContainer);
